import {ServiceBase} from "../service-base";
import {IApplicationService} from "./application.service.interface";
import {IServiceFactory} from "../service-factory.interface";
import {makeObservable, observable} from "mobx";
import {ApplicationEnvironmentTypeEnum} from "../../env.configs.interface";

export class ApplicationService extends ServiceBase implements IApplicationService {
    constructor(services: IServiceFactory) {
        super(services);


        makeObservable(this, {
            isActive: observable.ref,
        });

    }
    isActive = true;



    get isInMobileView(): boolean {
        return this.services.screenMediaQuery.sAndBelow;
    }

    sendEnvironmentTypeEvent(environmentType: ApplicationEnvironmentTypeEnum): void {
        if(environmentType === ApplicationEnvironmentTypeEnum.Production) {
            return;
        }

        const getEnvironmentName = () => {
            switch (environmentType) {
                case ApplicationEnvironmentTypeEnum.Development:
                    return 'dev';
                case ApplicationEnvironmentTypeEnum.Test:
                    return 'test';
                case ApplicationEnvironmentTypeEnum.Stage:
                    return 'stage';
                default:
                    return 'prod';
            }
        }

        const msg = {
            topic: 'set-environment',
            content: getEnvironmentName()
        };

        this.services.logger.debug('Sending message', msg);
        this.services.window.postMessage(msg);
    }
}
